import { useContext } from 'react';
import { AbilityContext } from './AbilityContext';

/**
 * Allow imperative use of user's abilities
 */
export function useAbilities() {
  return useContext(AbilityContext);
}
